import React from 'react';
import Barcode from 'react-barcode';
import { Box, Typography } from '@mui/material';

interface BarcodeStickerProps {
  productName: string;
  barcode: string;
  price: number;
  tenantName?: string;
}

const BarcodeSticker: React.FC<BarcodeStickerProps> = ({ 
  productName, 
  barcode, 
  price, 
  tenantName = 'Akmo Books' 
}) => {
  return (
    <Box
      sx={{
        width: '50mm',
        height: '25mm',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '1mm 2mm',
        boxSizing: 'border-box',
        backgroundColor: '#fff',
        color: '#000',
        overflow: 'hidden',
        pageBreakInside: 'avoid',
        border: '1px solid #ccc',
        fontFamily: 'monospace',
        '@media print': {
          border: 'none',
          margin: 0,
          width: '50mm',
          height: '25mm',
        }
      }}
    >
      <Typography 
        sx={{ 
          fontSize: '6px', 
          fontWeight: 'bold', 
          textTransform: 'uppercase', 
          lineHeight: 1,
          mb: 0.5,
          fontFamily: 'monospace'
        }}
      >
        {tenantName}
      </Typography>
      
      <Typography 
        sx={{ 
          fontSize: '8px', 
          fontWeight: '600', 
          textAlign: 'center', 
          lineHeight: 1.1,
          width: '100%',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          fontFamily: 'sans-serif'
        }}
      >
        {productName}
      </Typography>

      <Box sx={{ my: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Barcode 
          value={barcode} 
          width={1} 
          height={20} 
          fontSize={8} 
          margin={0} 
          displayValue={true} 
          background="#ffffff"
          lineColor="#000000"
        />
      </Box>

      <Typography 
        sx={{ 
          fontSize: '9px', 
          fontWeight: '900', 
          lineHeight: 1,
          fontFamily: 'sans-serif'
        }}
      >
        MRP: ₹{price}
      </Typography>
    </Box>
  );
};

export default BarcodeSticker;
